module.exports = __webpack_public_path__ + "img/cast_resources_banner.038e35bc.png";